import {
  PAYMENT_STATUS_LOADING,
  PAYMENT_STATUS_SUCCESS,
  PAYMENT_STATUS_FAILURE,
} from "redux/types";

const initialState = {
  paymentStatusLoading: false,
  paymentStatus: null,
  errors: null,
};

export const paymentStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PAYMENT_STATUS_LOADING:
      return { ...state, paymentStatusLoading: action.payload };
    case PAYMENT_STATUS_SUCCESS:
      return { ...state, paymentStatus: action.payload };
    case PAYMENT_STATUS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
